import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";

@Injectable()
export class CampaignService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public saveCampaign(body: any): Observable<any> {
    return this.httpHelperService.post(`/campaign`, body);
  }
  public getCampaignList(userId): Observable<any> {
    return this.httpHelperService.get(`/sales/campaign/admin?userId=${userId}`);
  }

  public editCampaign(payload) {
    return this.httpHelperService.post(
      `/sales/campaign/${payload.campaignId}`,
      payload,
    );
  }

  public createCampaign() {
    return this.httpHelperService.postXmlRequest(`/sales/campaign`);
  }

  public uploadExcelFile() {
    return this.httpHelperService.postXmlRequest(`/campaign/upload`);
  }

  public previewCampagin() {
    return this.httpHelperService.postXmlRequest(`/sales/campaign/preview`);
  }

  public updateCampaign() {
    return this.httpHelperService.postXmlRequest(
      `/sales/campaign/update-detail`,
    );
  }

  public getCampaignSummary(payload): Observable<any> {
    let apiEndpoint = `/sales/campaign?userId=${payload.userId}&time=${payload.time}`;
    if (payload.agentCode) {
      apiEndpoint = apiEndpoint.concat(`&agentCode=${payload.agentCode}`);
    }

    return this.httpHelperService.get(apiEndpoint);
  }

  public setCampaignArchived(body): Observable<any> {
    return this.httpHelperService.post(`/sales/campaign/archive/${body.id}`);
  }

  public getBdmAgentList(userId: string) {
    return this.httpHelperService.get(`/sales/bdm-agents?userId=${userId}`);
  }

  public getCampaignCategoryLov() {
    return this.httpHelperService.get(`/sales/lov`);
  }

  public getCampaignFile(userId: string): Observable<any> {
    return this.httpHelperService.get(`/sales/campaign/download/${userId}`);
  }

  public validateCampaignRank() {
    return this.httpHelperService.postXmlRequest(
      `/sales/campaign/club/validate`,
    );
  }

  public createClubCampaign(payload) {
    return this.httpHelperService.post(`/sales/campaign/club`, payload);
  }

  public updateClubCampaign(payload) {
    return this.httpHelperService.post(
      `/sales/campaign/club/${payload.campaignId}`,
      payload,
    );
  }

  public editClubCampaign(payload) {
    return this.updateClubCampaign(payload);
  }

  public getClubCampaign(payload) {
    return this.httpHelperService.get(
      `/sales/campaign/club/${payload.campaignId}`,
    );
  }

  public getAgentsSearchList(payload): Observable<any> {
    return this.httpHelperService.get(
      `/sales/campaign/untagged-agents?mainAgentCode=${payload.mainAgentCode}&search=${payload.search}`,
    );
  }

  public getAgentsSummaryList() {
    return this.httpHelperService.get(`/sales/campaign/agent-tagging`);
  }

  public getAgentsList(payload) {
    return this.httpHelperService.get(
      `/sales/campaign/agent-tagging/${payload}`,
    );
  }

  public saveAgentTagging(payload) {
    return this.httpHelperService.post(
      `/sales/campaign/agent-tagging`,
      payload,
    );
  }

  public getSearchUntaggedAgentsList(search: string = "") {
    return this.httpHelperService.get(
      `/sales/campaign/search-untagged-agents?search=${search}`,
    );
  }
}
